import React from "react";

export const DocInstructionSvg = (props) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 10.8 14.3"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.9 4.9v8.5a1.8 1.8 0 01-1.8 1.8v-.9a.9.9 0 00.9-.9V4.9h-1.8a1.3 1.3 0 01-1.3-1.4V1.7H5a.9.9 0 00-.9.9v8.1h-.9V2.6A1.8 1.8 0 015 .8h4.9z"
        transform="translate(-3.2 -.8)"
      ></path>
      <path
        d="M5.8 11.4a2.2 2.2 0 114.4 0 2.4 2.4 0 01-.7 1.6l-.2.2-.2.7H6.9l-.3-.7V13a2 2 0 01-.8-1.6zm1.1 3.1l.2-.2h1.8l.2.2-.2.2v.2l-.3.2h-1c-.2 0-.3-.1-.3-.2v-.2z"
        transform="translate(-3.2 -.8)"
      ></path>
    </svg>
  );
}
